export enum Programs {
    DEBITO = 'DEBITO',
    CREDITO = 'CREDITO',
    'PRE-PAGO' = 'PRE-PAGO',
    'CREDITO ZERO-BALANCE' = 'CREDITO ZERO-BALANCE',
    'DEBITO ZERO-BALANCE' = 'DEBITO ZERO-BALANCE',
    'PRE-PAGO ZERO-BALANCE' = 'PRE-PAGO ZERO-BALANCE',
    LENDING = 'LENDING',
    'CURRENT ACCOUNTS' = 'CURRENT ACCOUNTS',
    MERCHANT = 'MERCHANT',
    'INTERNAL ACCOUNTS' = 'INTERNAL ACCOUNTS',
    'CORRESPONDENT ACCOUNTS' = 'CORRESPONDENT ACCOUNTS',
    'CHECKING ACCOUNT' = 'checking account',
}
